import { bridge, Viewer } from '@sloyd/viewer';
import { useEffect, useState } from 'react';
import { Actions, Wrapper } from './EmbedCanvas.style';

export type EmbedCanvasProps = {
  model: IModel;
  children?: React.ReactNode;
};

const INSTANCE_ID = 'default';

export function EmbedCanvas(props: EmbedCanvasProps) {
  const { model } = props;

  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!isReady) return;
    bridge.patchEnvironment(INSTANCE_ID, { lightIntensity: 1.6 });
  }, [isReady]);

  useEffect(() => {
    if (!isReady) return;
    bridge.replaceModel(INSTANCE_ID, model);
  }, [model, isReady]);

  function onReady() {
    setIsReady(true);
  }

  return (
    <Wrapper>
      <Viewer id={INSTANCE_ID} onReady={onReady} />
      <Actions>{props.children}</Actions>
    </Wrapper>
  );
}

export default EmbedCanvas;
